import React from 'react'
import PageIntro from '../components/PageIntro/PageIntro'
import FirstPage from '../components/FirstSection/firstSection'

export const Blog = () => {
    return (
        <div className='mx-auto max-w-7xl space-y-6'>
            <PageIntro
                title='Create Post'
                description='Publish a new article to the Droomwork blog.'
            />
            <FirstPage />
        </div>
    )
}
